import { render } from "./questionaireScreen.vue?vue&type=template&id=f63ca99c&ts=true"
import script from "./questionaireScreen.vue?vue&type=script&lang=ts"
export * from "./questionaireScreen.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__